import { MAX_ZONE_BORDER_WIDTH } from "../../utils/location/location-map-utils";
import { DEFAULT_OVERLAY_SWATCH } from "./overlay-colors";

export type OverlayPaint = {
	color: OverlayColorExpression;
	fillOpacity: OverlayOpacityExpression;
	lineOpacity: OverlayOpacityExpression;
	lineWidth: OverlayLineWidth;
};

type OverlayColorExpression = [
	"coalesce",
	["get", "overlayColorDark" | "overlayColorLight"],
	string,
];

type OverlayLineWidth = [
	"case",
	["has", "lineWidth"],
	["max", number, ["min", number, ["to-number", ["get", "lineWidth"]]]],
	number,
];

/**
 * Dimmed overlays interpolate opacity with numeric feature-state `hover` (0–1).
 * Non-dimmed overlays ignore hover and stay at full opacity.
 */
type OverlayOpacityExpression = [
	"case",
	["==", ["get", "dimmed"], true],
	[
		"interpolate",
		["linear"],
		["coalesce", ["feature-state", "hover"], 0],
		0,
		number,
		1,
		number,
	],
	number,
];

const overlayColorProperty = (
	isDarkTheme: boolean,
): "overlayColorDark" | "overlayColorLight" =>
	isDarkTheme ? "overlayColorDark" : "overlayColorLight";

export const overlayPaint = (isDarkTheme: boolean): OverlayPaint => ({
	color: [
		"coalesce",
		["get", overlayColorProperty(isDarkTheme)],
		isDarkTheme ? DEFAULT_OVERLAY_SWATCH.dark : DEFAULT_OVERLAY_SWATCH.light,
	],
	fillOpacity: [
		"case",
		["==", ["get", "dimmed"], true],
		[
			"interpolate",
			["linear"],
			["coalesce", ["feature-state", "hover"], 0],
			0,
			isDarkTheme ? 0.08 : 0.04,
			1,
			isDarkTheme ? 0.24 : 0.18,
		],
		isDarkTheme ? 0.38 : 0.32,
	],
	lineOpacity: [
		"case",
		["==", ["get", "dimmed"], true],
		[
			"interpolate",
			["linear"],
			["coalesce", ["feature-state", "hover"], 0],
			0,
			isDarkTheme ? 0.55 : 0.25,
			1,
			isDarkTheme ? 0.9 : 0.7,
		],
		isDarkTheme ? 1 : 0.85,
	],
	lineWidth: [
		"case",
		["has", "lineWidth"],
		[
			"max",
			0,
			["min", MAX_ZONE_BORDER_WIDTH, ["to-number", ["get", "lineWidth"]]],
		],
		isDarkTheme ? 3 : 2,
	],
});
